<template>

    <w-transition-bounce>
        <!-- <w-alert v-if="success" style="color: green;" success icon-outside>{{success}}</w-alert> -->
        </w-transition-bounce>

        <w-transition-bounce>
        <w-alert
          class="my0 mb2 text-light"
          bg-color="pink" color="white"
          v-if="salah"
          error
          transition="bounce"
          plain
          round
          no-border
          dismiss
          >
            {{salah}}
        </w-alert>
    </w-transition-bounce>

    <w-notification
        v-if="$page.props.flash.notify"
        success
        transition="bounce"
        absolute
        plain
        round
        timeout="2000"
        @close="$page.props.flash.notify = ''"
        >
        {{$page.props.flash.notify}}
    </w-notification>

    <w-notification
        v-if="$page.props.flash.notifyerror"
        error
        transition="bounce"
        absolute
        plain
        round
        timeout="2000"
        @close="$page.props.flash.notifyerror = ''"
        >
        {{$page.props.flash.notifyerror}}
    </w-notification>

    <layout :showuserinfo="false" >

       
      	<div class="container-fluid h-100">
            <div class="container d-flex justify-content-center mt-5">
                <img src="assets/images/logo-ibayaq.png" style="width: 60%;">

            </div>

            <div class="page-wrapper-portal card-pkn mt-5">
                
                <div class="card card-scroll" >
                    <div class="card-body">

                        <!-- -->
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="row justify-content-center">
                                    
                                    <!-- -->
                                    <div class="">
                                        <div class="card report-card">
                                            <div class="card-body">


                                                
                                                <!-- -->
                                                <!-- -->
                                                <div class="col-lg-12">
                                                    <div class="card">

                                                        <div class="card-header"><h4 class="card-title"><i class="mdi mdi-lock-outline font-16 me-2"></i> Lupa Kata Laluan</h4></div><!--end card-header-->



                                                         <w-form @validate="forgotPassword" v-model="form.valid">
                                                            <div class="card-body">
                                                                 <w-alert
                                                                class="my0 mb2 text-light"
                                                                v-if="success"
                                                                success
                                                                transition="bounce"
                                                                plain
                                                                round
                                                                no-border
                                                                dismiss
                                                                >
                                                                    {{ success }}
                                                                </w-alert>
                                                                <div class="table-responsive shopping-cart">
                                                                       <div class="form-group mt-2">
                                                <label for="email" class="form-label  mb-2">Emel</label>
                                                <w-input 
                                                    outline
                                                    placeholder="Sila Masukkan Emel Pengguna"
                                                    type="email"  
                                                    name="email"
                                                    v-model="form.email"
                                                    :validators="[validators.required, validators.email]"
                                                /> 
                                                <template v-if='email_wujud'>
                                                <div style="color: red;">
                                                {{email_wujud}}  
                                                </div>  
                                                </template>                               
                                            </div><!--end form-group-->

                                                                    <w-button class="mt4 mb2 ml2" type="" @click="back">Tutup</w-button>
                                                                    <!-- <button class="btn btn-lupa-katalaluan-1 mt4 mb2 ml2" type="" @click="back">Tutup</button> -->

                                                                    <w-button  class="mt4 mb2 ml2" type="submit"  :loading="loading">Hantar</w-button>
                                                                    
                                                                    <!-- <code>* <b>Nota</b> : Sila Pastikan Setiap Pembayaran adalah tepat dan betul, sebelom melakukan pembayaran. Terima Kasih</code> -->

                                                                </div><!--end re-table-->

                                                            </div><!--end card-body-->
                                                         </w-form>
                                                    </div>
                                                </div><!--end col--> 
                                                <!-- -->
                                                <!-- -->

                                            </div><!--end card-body--> 

                                        </div><!--end card--> 
                                    </div> <!--end col--> 

                                    <!-- -->

                                </div><!--end row-->

                            </div><!--end col-->

                        </div><!--end row-->
                        <!-- -->

                    </div><!--end card-body--> 
                </div>

            </div>
        </div>
    </layout>
</template>

<script type="text/javascript">
import ZResource from '@/Modules/z-resource'

	export default {
        extends: ZResource,
	components: {
	  
	},
	setup () {

	},
	data() {
	    return {
             loading : false,
         email_wujud: '',

      form: {
	    valid: null,
	    submitted: false,
	    sent: false,
	    errorsCount: 0,
        no_id: '',
		email: '',
	  },
         success : '',
      salah : '',
    
	}},
	methods: {
      
       back() {
            window.history.back();
        },
	 
      forgotPassword() {
        this.loading = true,
            this.$zcomm.post('forget.password.post',this.form).then(res => {
                          this.notify('Sila Semak Emel Anda Untuk Pertukaran Kata Laluan', 1)
                          this.loading = false
                          
                        })
                         .catch(err => {
                             this.loading = false
                       if (err.response.data.errors.email == "The selected email is invalid."){
                            //   console.log(err.response.data.errors.email);

                                this.email_wujud = 'Emel yang dimasukkan tidak wujud'
  
                        }
                        })
        },
        
        notify(msg, success = true) {
            if(success)
            
            this.success = msg
            else
            this.salah = msg
        }
	},
  mounted() {
    // override default setting
    

    this.cari = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.cari.no_rujukan){
    	this.no_rujukan = this.cari.no_rujukan
    	this.carian();
    }
   
    
      
  }
}
</script>
<style type="text/css">
	.card-scroll {
    height: 510px;
    max-height: 510px;
    overflow-y: scroll;
    background: ivory;
}

</style>